import { 
    FORMULARIO_PROYECTO,
    FORMULARIO_EDITAR,
    OBTENER_PROYECTOS,
    OBTENER_ULTIMOS_CAMBIOS,
    ULTIMO_CAMIBIO,
    AGREGAR_PROYECTO,
    VALIDACION_FORMULARIO,
    PROYECTO_ACTUAL,
    ELIMINAR_PROYECTO,
    ACTUALIZAR_PROYECTO,
    CAMBIAR_VISTA,
    CAMBIAR_PROYECTO,
    CAMBIAR_ALTURA_CONTENEDOR,
    REINICIAR_PROYECTO_STATE
} from '../../types';

export default (state, action) => {
    switch(action.type) {
        case FORMULARIO_PROYECTO:
            return {
                ...state,
                formulario: true
            }
        case FORMULARIO_EDITAR:
            return {
                ...state,
                formulario: true,
                formularioeditar: true
            }
        case OBTENER_PROYECTOS:
            return {
                ...state,
                proyectos: action.payload
            }
        case OBTENER_ULTIMOS_CAMBIOS:
            return {
                ...state,
                ultimoscambiosproyecto: action.payload
            }
        case ULTIMO_CAMIBIO:
            return {
                ...state,
                ultimoscambiosproyecto: [action.payload, ...state.ultimoscambiosproyecto]
            }
        case AGREGAR_PROYECTO:
            return {
                ...state,
                proyectos: [...state.proyectos, action.payload],
                formulario: false,
                errorformulario: false
            }
        case VALIDACION_FORMULARIO:
            return {
                ...state,
                errorformulario: action.payload
            }
        case PROYECTO_ACTUAL:
            return {
                ...state,
                proyecto: state.proyectos.filter(proyecto => proyecto._id === action.payload)
            }
        case ELIMINAR_PROYECTO:
            return {
                ...state,
                proyectos: state.proyectos.filter(proyecto => proyecto._id !== action.payload),
                proyecto: null,
                proyectoactivo: false
            }
        case ACTUALIZAR_PROYECTO:
            return {
                ...state,
                proyectos: state.proyectos.map(proyecto => proyecto._id === action.payload._id ? action.payload : proyecto),
                formulario: false,
                formularioeditar: false,
                errorformulario: false
            }
        case CAMBIAR_VISTA:
            return {
                ...state,
                verdetalles: action.payload
            }
        case CAMBIAR_PROYECTO:
            return {
                ...state,
                proyectoactivo: action.payload
            }
        case CAMBIAR_ALTURA_CONTENEDOR:
            return {
                ...state,
                alturaactualcontenedor: action.payload
            }
        case REINICIAR_PROYECTO_STATE:
            return {
                ...state,
                proyectos: [],
                ultimoscambiosproyecto: [],
                formulario: false,
                formularioeditar: false,
                errorformulario: false,
                proyecto: null,
                verdetalles: false,
                proyectoactivo: false,
                alturaactualcontenedor: window.innerHeight - 56,
                mensaje: null
            }
        default:
            return state;
    }
}